import React from "react"
import useTopicCollection from "hooks/useTopicCollection"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import * as Icons from "@bw/icons"

const TopicsWrapper = styled.nav`
  ${props =>
    props.mobile
      ? css`
          display: grid;
          grid-gap: 20px;

          svg {
            width: 50px;
            height: auto;
            margin-right: 10px;
          }
          a {
            color: var(--text-color);
            filter: none;
          }
          a:hover {
            transform: none;
          }
        `
      : css`
          display: none;
          @media (min-width: 500px) {
            display: flex;
            flex-direction: column;
            position: ${props => (props.isFixed ? "fixed" : "absolute")};
            left: 5px;
            top: 45px;
            z-index: 10;
          }

          @media (min-width: 1200px) {
            left: calc(50vw - 495px - 90px);
          }
        `}
`

const StyledLink = styled(Link)`
  transition: transform 0.2s ease-in-out;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.4s ease-in.out;
  width: 100%;
  filter: grayscale(0.4);

  &:hover {
    filter: grayscale(0);
    transform: scale(1.2);
  }
`

const Topics = ({ mobile }) => {
  const topics = useTopicCollection()
  const [isFixed, setIsFixed] = React.useState(false)

  React.useEffect(() => {
    const updateWindowDimensions = () => {
      const newHeight = window.innerHeight
      setIsFixed(newHeight > topics.length * 62)
    }

    window.addEventListener("resize", updateWindowDimensions)

    return () => window.removeEventListener("resize", updateWindowDimensions)
  }, [topics.length])

  return (
    <TopicsWrapper mobile={mobile} isFixed={!mobile && isFixed}>
      {topics.map(topic => {
        const TopicIcon =
          typeof Icons[topic.icon.value] !== "undefined"
            ? Icons[topic.icon.value]
            : Icons.Vide
        return (
          <div
            key={topic.url}
            data-place="right"
            data-offset="{'right': 20}"
            data-tip={mobile ? null : topic.title}
          >
            <StyledLink to={topic.url}>
              <TopicIcon />
              {mobile && topic.title}
            </StyledLink>
          </div>
        )
      })}
    </TopicsWrapper>
  )
}

Topics.defaultProps = {
  mobile: false,
}

export { Topics }
